import { PRIORITY_TONE } from "@/lib/constants";

export default function PriorityBadge({ priority, className = "" }) {
  const tone = PRIORITY_TONE[priority] || "slate";
  return (
    <span
      data-testid={`priority-badge-${priority}`}
      className={`md-status-badge md-status-${tone} rounded-md px-1.5 py-0.5 text-[11px] font-mono ${className}`}
    >
      {priority}
    </span>
  );
}
